import { ApplyButton } from 'components/ApplyButton/ApplyButton';
import { RsvpButton } from 'components/ApplyButton/RsvpButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { SaveButton } from 'components/SaveButton/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import type { ApiEvent } from 'modules/listing/api/event/types/ApiEvent';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { OrgDashboardApiEvent } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiEvent';

type Props = {
  event: ApiEvent | OrgDashboardApiEvent;
};

export function ViewEventActionButtons({ event }: Props) {
  const { id, hasRsvp, name, type, url, org } = event;

  return (
    <ListingViewActionButtons>
      {hasRsvp ? (
        <RsvpButton listingId={id} />
      ) : (
        <ApplyButton atsIsEnabled={false} listingId={id} size="medium" />
      )}

      <SaveButton
        listingId={id}
        listingType={type}
        listingName={name}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        hasAts={false}
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgId={org?.id}
        orgName={org?.name}
        orgType={org?.orgType}
      />
    </ListingViewActionButtons>
  );
}
